import { css, Theme } from "@emotion/react";

export const MPhoneNumberCardStyle = {
  self: ({ colors }: Theme) => css`
    background-color: ${colors.white};
    height: 100%;
  `,
  cardBody: ({ colors }: Theme) => css`
    border-radius: 4px;
    background-color: ${colors.white};
    padding: 14px;
    border: 1px solid rgb(204 204 204 / 1);
  `,

  alert: ({ fontSize }: Theme) => css`
    color: rgb(161 98 7 /1);
    background-color: rgb(254 249 195 / 1);
    padding: 15px;
    border-radius: 4px;
    font-size: ${fontSize[14]};
  `,
};
